import { get, put } from "@/infra/rest";
import type { IntakeFormQuestionV2 } from "@/modules/third-party-risk/types/intake-form-v2";

export interface IntakeFormV2Response {
  success: boolean;
  questions: IntakeFormQuestionV2[];
}

export interface SaveIntakeFormPayload {
  questions: IntakeFormQuestionV2[];
}

export interface SaveIntakeFormResponse {
  success: boolean;
  questions: IntakeFormQuestionV2[];
}

/**
 * Get organization's intake form (V2)
 */
export const getIntakeForm = async (): Promise<IntakeFormV2Response> => {
  return get<IntakeFormV2Response>({
    url: '/v0/tpra/intake-form-v2',
    isAuthRequired: true,
  });
};

/**
 * Save intake form after editing (V2 — full replacement)
 */
export const saveIntakeForm = async (
  payload: SaveIntakeFormPayload
): Promise<SaveIntakeFormResponse> => {
  return put<SaveIntakeFormPayload, SaveIntakeFormResponse>({
    url: '/v0/tpra/intake-form-v2',
    data: payload,
    isAuthRequired: true,
  });
};
